import DashboardClinicalAssignmentItem from "./DashboardClinicalAssignmentItem";

export default DashboardClinicalAssignmentItem;
